<style lang="sass">
.order-list
  padding: 20px 20px 62px
  border: 1px solid #e9e9e9
  height: calc(100% - 65px)
  position: relative
  min-width: 900px
  ::v-deep .el-table
    border-top: none
    height: 100%
    .el-table__header
      background: #F1F1F1
      .cell
        border-right: 1px solid #D4D4D4
        color: #282729
        height: 24px
        line-height: 24px
      .is-leaf
        border-right: none
        background: #F1F1F1
    .el-table__row
      td
        padding: 10px 0
  .page_box
    height: 60px
    padding: 6px 10px
    border-left: 1px solid #E9E9E9
    border-right: 1px solid #E9E9E9

.row_order
  text-align: left
  p
    line-height: 1
    margin-top: 10px
    padding-left: 20px
  .order_no
    background: rgba(255, 57, 115, 0.1)
    line-height: 30px
    color: #282729
    padding-left: 20px
    .time
      display: inline-block
      margin-right: 20px
  .time
    color: #282729
    font-weight: 600
  .color_999
    color: #999
    font-size: 12px
  .area
    line-height: 1.5
    color: #282729

.fix-center.cancel-box
  .fix-center-main
    padding: 20px 20px 0!important

.reasons
  text-align: center
  .el-radio-group
    width: 280px
    margin: 20px auto 0
    text-align: left
    overflow: hidden
    .el-radio
      width: 50%
      margin-bottom: 10px
      color: #999
      &+.el-radio
        margin-left: 0
      .el-radio__input.is-checked
        .el-radio__inner
          background: #fff
          border-color: #282729
          transition: none
          &::after
            background: #282729
            width: 6px
            height: 6px
            transition: none
        &+.el-radio__label
          color: #282729
  .radio-group
    margin: 20px auto 0
  .text
    width: 280px
    margin: 0 auto
    .el-textarea
      textarea
        height: 90px
        resize: none
        font-size: 12px
  .tip
    font-size: 16px
    line-height: 80px
    border-top: 1px solid #e9e9e9
    margin-top: 15px

.judge_box
  text-align: center
  .star-str
    font-size: 16px
    margin-bottom: 10px
  img
    width: 25px
    margin: 10px
    cursor: pointer
  .text-area
    margin: 8px auto 0
    width: 280px
  .el-textarea
    textarea
      height: 120px
      font-size: 12px
      resize: none

.order
  .p-main
    padding: 0

.list_search
  padding: 15px 20px
  background: #F5F5F5

.order-list
  ::v-deep .el-table--mini, .el-table--small, .el-table__expand-icon
    thead
      font-size: 14px

</style>

<template lang="pug">
.order
  .p-title 我的订单
  .p-main
    div(style="height: 100%;")
      .list_search
        ListSearchCp(
          @change="data => { searchOpt = data; getList(1); }"
          :orderTagList="orderTagList"
          )
      .order-list
        ListTable(
          :data="tableData"
          :orderTagList="orderTagList"
          @orderDetail="seeOrderDetail"
          @setCurrentDetail="setCurrentDetail"
          @watchDetail="orderPutDetail"
          @showMonitService="showMonitService"
          @codeService="showCodeServe"
          @cancelOrder="cancelOrder"
          @giveMark="giveMark"
        )

        Pagination.page_box(:autoLoad="false" :total="pageInfo.total" :current-page.sync="pageInfo.current" :size.sync="pageInfo.size" @fn-change="getList")

  UploadVideo(v-model="currentRow" @upDone="upDone")

  PutDetail(:show.sync="isWatchDetail" :orderInfo="orderDto")

  MonitPopper(v-if="showMonit" :show.sync="showMonit" :orderInfo="orderDto")

  CodeServe(v-if="popCode" :show.sync="popCode" :order="curOrder" @close="onClose")

  fix-center.cancel-box(ref="cancelFixCenter" w="400" :h="cancelBoxHeight" @close="cancelCancel")
    template(slot="title") 取消订单
    template(slot="main")
      .cancel-main 您取消订单的原因是：
        .reasons
          //- el-radio-group(v-model="curReasonIdx")
            el-radio(
              v-for="(item, i) in reasons" :key="i"
              :label="i" :class="{'cur':curReasonIdx == i}"
            ) {{item}}
          .radio-group(v-model="curReasonIdx")
            .radio(
              @click="curReasonIdx=i"
              v-for="(item, i) in reasons" :key="i"
              :label="i" :class="{'cur':curReasonIdx == i}"
            ) {{item}}
              .circle
                .black

          .text-area.text(v-if="curReasonIdx==6")
            el-input(type="textarea" v-model="reasonStr" placeholder="请输入原因" maxlength="100")
            .text-num {{reasonStr.length}}
              span /100

          .tip 温馨提示：订单取消后将无法恢复
    template(slot="btm")
      .fix-btn.red(@click="cancel") 确认并取消订单
      .fix-btn(@click="cancelCancel") 取消

  fix-center(ref="judgeFixCenter" w="400" h="385" @close="hideMarkPop")
    template(slot="title") 我要评价
    .judge_box(slot="main")
      .star-str {{starStr}}
      template(v-for="(item, i) in starIdx+1")
        img(src="../../assets/star1.png" v-if="starIdx<2" @click="starIdx=i")
        img(src="../../assets/star2.png" v-if="starIdx==2" @click="starIdx=i")
        img(src="../../assets/star3.png" v-if="starIdx>2" @click="starIdx=i")
      template(v-for="(item, i) in 5-starIdx-1")
        img(src="../../assets/star0.png" @click="starIdx=starIdx+i+1")

      .text-area
        el-input(type="textarea" v-model="judgeStr" placeholder="请写下你的感受，对我们会有很大帮助哦～" maxlength="200")
        .text-num {{judgeStr.length}}
          span /200

    template(slot="btm")
      .fix-btn.red(@click="judge") 提交评价
      .fix-btn(@click="hideMarkPop") 取消
</template>

<script>
import { mapState } from "vuex"
import ListSearchCp from "@/components/ListSearchCp"
import ListTable from "./ListTable"
import Pagination from "@/components/Pagination"
import UploadVideo from "@/components/UploadVideo"
import PutDetail from "@/components/PutDetail/PutDetail"
import MonitPopper from "@/components/MonitService/IndexPopper"
import CodeServe from "./components/QrCodeServe"
import { getOrderList } from "@/utils/api"

export default {
  name: "OrderList",
  components: { ListSearchCp, ListTable, Pagination, UploadVideo, PutDetail, MonitPopper, CodeServe },
  data() {
    return {
      searchOpt: { creatorName: '' },
      tabs: [],
      tableData: [],
      pageInfo: { total: 0, current: 1, size: 20 },
      currentRow: {},
      delItem: null,
      reasons: ["支付不成功", "忘记使用优惠券", "订单价格有问题", "广告位价格较高", "错误或重复购买", "现在不想购买", "其他"],
      curReasonIdx: -1,
      types: [],
      cancelBoxHeight: 385,
      reasonStr: "",
      judgeStr: "",
      starIdx: -1,
      isWatchDetail: false,
      showMonit: false,
      orderDto: {},
      curOrder: {},
      popCode: false,
      orderTagList:[],
    }
  },
  mounted() {
    this.getOrderTagList()
  },
  activated() {
    this.getOrderTagList()
  },
  computed: {
    ...mapState({
      adUser: s => {
        return s ? s.customer.userInfo : {}
      }
    }),
    starStr() {
      let arr = ["效果非常差，联系客服", "效果很差，我要吐槽", "效果一般，需要改善", "效果很好，再接再厉", "效果非常好，无可挑剔"]
      if (this.starIdx > -1) return arr[this.starIdx]
      return "效果满意度"
    }
  },
  watch: {
    curReasonIdx(v) {
      if (v == 6) this.cancelBoxHeight = 495
      else {
        this.cancelBoxHeight = 385
        this.reasonStr = ""
      }
    },
    'adUser.userName'(v) {
      if (v && v.length) this.searchOpt.creatorName = v
    }
  },
  methods: {
    // 获取组别
    async getOrderTagList() {
      const result = await this.fetch('/orderlite/contract/api/v4/contract/order-groups/page', {
        pageNum: 1,
        pageSize:99999
      },'post')
      if (result.code === 0) {
        this.orderTagList = result.data?.list || []
      } else {
        this.orderTagList = []
      }
    },
    // 码上服务(溯源码、监播码)
    showCodeServe(adOrder) {
      this.curOrder = adOrder
      this.popCode = true
    },
    onClose() {
      this.curOrder = {}
      this.popCode = false
    },
    async getTypes() {
      let res = await this.fetch("/boss/common/config/v2/getOrderStatusTab", "", "get")
      if (res && res.code === 0) {
        this.types = res.data || []
        this.tabs = ["全部", ...this.types.map((el) => el.dictItemName)]
      }
    },
    // 素材上传完成后更新layout组件顶部未发布订单提示消息
    upDone() {
      this.$parent.getHandleOrder()
      this.getList()
    },
    async getList(p) {
      if (p && typeof p == "number") this.pageInfo.current = p
      this.tableData = []
      let param = {
        ...this.searchOpt,
        pageIndex: this.pageInfo.current,
        pageSize: this.pageInfo.size
      }
      let loading = this.$loading()
      let response = await getOrderList(param)
      loading.close()
      if (response.data) {
        this.tableData = (response.data.list || []).map((el) => {
          const now = new Date().setHours(0, 0, 0, 0)

          let expt = new Date(el.startDate)
          expt.setDate(expt.getDate() + 60)
          expt.setHours(0, 0, 0, 0)
          // 监播图片是否有效(固定60天有效期)
          el.noMonit = now - expt > 0

          // 溯源图片是否失效(已过有效期)
          el.traceExpired = now >= new Date(el.pictureExpirationTime).setHours(0, 0, 0, 0)
          return el
        })
        this.pageInfo.total = response.data.total || 0
      }
    },
    // 广告订单详情
    async seeOrderDetail(row) {
      this.goUrl("/mapOrderDetail", { id: row.guid })
      tzx_czcPush("order_list", "detail")
    },
    // 订单投放详情
    async orderPutDetail(row) {
      let { guid, startDate = "", dateList = [] } = row
      this.orderDto = { guid, startDate, dateList }
      this.isWatchDetail = true
    },
    async showMonitService(row) {
      if (row.noMonit) return
      const { guid, contentGuid, orderCode, startDate, endDate, timeSlotNames } = row
      if (!guid) return this.messageTip("无效的订单id，请联系客服")
      this.orderDto = { guid, contentGuid, orderCode, startDate, endDate, timeSlotNames }
      this.showMonit = true
    },
    async setCurrentDetail(row, type) {
      this.currentRow = {
        ...row
      }
      if (type == "showUpload") {
        this.currentRow.advContentDto = await this.getOldResource(this.currentRow)
      }
      this.$set(this.currentRow, type, true)
    },
    async getOldResource(item) {
      let res = await this.fetch("/dsp/content/v2/queryContentByOrder?orderGuid=" + item.guid, "", "get")
      if (res && res.code == this.successCode) return res.data[0] || {}
      else return {}
    },
    cancelOrder(row) {
      this.delItem = row
      this.$refs.cancelFixCenter.show()
    },
    cancelCancel() {
      this.delItem = null
      this.curReasonIdx = -1
      this.reasonStr = ""
      this.$refs.cancelFixCenter.hide()
    },
    async cancel() {
      if (this.curReasonIdx == -1) return this.messageTip("请选择取消理由")
      if (this.curReasonIdx == this.reasons.length - 1 && this.reasonStr.trim() == "") {
        return this.messageTip("请填写取消原因")
      }
      let reason = this.reasons[this.curReasonIdx]
      if (this.curReasonIdx == this.reasons.length - 1) reason += ": " + this.reasonStr

      let load = this.$loading()
      let res = await this.fetch("/dsp/web/order/v2/canlOrder", {
        cancelDesc: reason,
        orderGuid: this.delItem.guid
      })
      load.close()

      if (res && res.code == this.successCode) {
        this.messageTip(res.msg || "取消成功", 1)
        this.cancelCancel()
        this.getList()

        tzx_czcPush("order_list", "cancelSuccess")
      } else tzx_czcPush("order_list", "cancelFail")
    },
    giveMark(row) {
      this.delItem = row
      this.$refs.judgeFixCenter.show()
    },
    hideMarkPop() {
      this.delItem = null
      this.starIdx = -1
      this.judgeStr = ""
      this.$refs.judgeFixCenter.hide()
    },
    async judge() {
      if (this.starIdx == -1) return this.messageTip("请选择评价等级")
      let res = await this.fetch("/dsp/orderaccess/v2/orderRate", {
        orderGuid: this.delItem.guid,
        appraisal: this.judgeStr.trim(),
        rate: this.starIdx + 1
      })
      if (res && res.code == this.successCode) {
        this.messageTip(res.msg || "取消成功", 1)
        this.hideMarkPop()
        this.getList()

        tzx_czcPush("order_list", "judgeSuccess")
      } else tzx_czcPush("order_list", "judgeFail")
    }
  }
}
</script>
